import {
  getData,
  postData,
  postData_,
  deleteDataMethod,
  putData,
} from "helpers/Helper";
import {
  APP_PATH,
  GET_BLOG,
  ADD_BLOG,
  UPDATE_BLOG,
  VIEW_BLOG,
  DELETE_BLOG,
} from "./apiPath";
import {
  getBlog,
  addBlog,
  updateBlog,
  viewBlog,
  deleteBlog,
} from "store/actions/blog";
import { persist_store } from "store/actions/index";

export function getBlog_(value, callback) {
  const { page, limit, url, common } = value || {};
  let urlPath = `${APP_PATH}${GET_BLOG}`;
  //   if (page !== undefined && limit !== undefined) {
  //     urlPath += `?page=${page}&limit=${limit}`;
  //   }
  return async (dispatch) => {
    // Set loader state to true before making the API call
    dispatch(persist_store({ loader: true }));
    // Make the API call
    try {
      const data = await postData_(urlPath, value);

      // Dispatch the getList action with the data received from the API
      dispatch(getBlog(data, callback));
      // Set loader state to false after the API call is complete
      dispatch(persist_store({ loader: false }));
      return data;
    } catch (error) {
      // In case of an error, also set loader state to false
      dispatch(persist_store({ loader: false }));
      // You might want to handle the error here or propagate it further
      console.error("Error fetching data:", error);
    }
  };
}

//add
export function addBlog_(value, callback) {
  return (dispatch) =>
    postData(`${APP_PATH}${ADD_BLOG}`, value).then((data) => {
      dispatch(addBlog(data, callback));
      return data;
    });
}

//view
export function viewBlog_(value, callback) {
  let urlPath = `${APP_PATH}${VIEW_BLOG}${value}`;
  return async (dispatch) => {
    dispatch(persist_store({ loader: true }));
    try {
      const data = await getData(urlPath, value);
      dispatch(viewBlog(data, callback));
      dispatch(persist_store({ loader: false }));
      return data;
    } catch (error) {
      dispatch(persist_store({ loader: false }));
      console.error("Error fetching data:", error);
    }
  };
}

export function updateBlog_(value, callback) {
  return (dispatch) =>
    putData(`${APP_PATH}${UPDATE_BLOG}${value?.blogId}`, value).then((data) => {
      dispatch(updateBlog(data, callback));
      return data;
    });
}

export function deleteBlog_(value, callback) {
  let url = `${APP_PATH}${DELETE_BLOG}${value?.blogId}`;
  return (dispatch) =>
    deleteDataMethod(url).then((data) => {
      dispatch(deleteBlog(data, callback));
      return data;
    });
}
